export default __webpack_public_path__ + "static/media/ssimg3.f5a86a9e.jpg";